import React from 'react';
import ConditionPanel from './ConditionPanel';
import ArithmeticPanel from './ArithmeticPanel';
import SwitchPanel from './SwitchPanel';
import LoopPanel from './LoopPanel';
import ForPanel from './ForPanel';
import ServicePanel from './ServicePanel';
import EmailPropertyPanel from './EmailPropertyPanel';
import SMSPropertyPanel from './SMSPropertyPanel';
import PLCCommandPropertyPanel from './PLCCommandPropertyPanel';
import StartPanel from './StartPanel';
import AlarmPanel from './AlarmPanel';
import ProgramCallPanel from './ProgramCallPanel';
import MetinselIslemlerPanel from './MetinselIslemlerPanel';
import AndPanel from './logic/AndPanel';
import OrPanel from './logic/OrPanel';
import NotPanel from './logic/NotPanel';
import XorPanel from './logic/XorPanel';
import EqPanel from './logic/EqPanel';
import RisingEdgePanel from './logic/RisingEdgePanel';
import ScenarioPanel from './ScenarioPanel';

const panelMap = {
  Start: StartPanel,
  Condition: ConditionPanel,
  Arithmetic: ArithmeticPanel,
  Switch: SwitchPanel,
  Loop: LoopPanel,
  For: ForPanel,
  Service: ServicePanel,
  ProgramCall: ProgramCallPanel,
  MetinselIslemler: MetinselIslemlerPanel,
  And: AndPanel,
  Or: OrPanel,
  Not: NotPanel,
  Xor: XorPanel,
  Eq: EqPanel,
  RisingEdge: RisingEdgePanel,
  Scenario: ScenarioPanel,
  Email: EmailPropertyPanel,
  SMS: SMSPropertyPanel,
  PLCCommand: PLCCommandPropertyPanel,
  Alarm: AlarmPanel,
};

export const PanelWrapper = ({ nodeType, nodeId, data, onChange }) => {
  const Panel = panelMap[nodeType];
  if (!Panel) return <div>Bu düğüm için panel bulunamadı: {nodeType}</div>;
  if (!data) return <div>Bu düğüm için veri yok.</div>;
  return (
    <div style={{ padding: 10 }}>
      <Panel nodeType={nodeType} nodeId={nodeId} data={data} onChange={onChange} />
    </div>
  );
};
